import { AUTH_BASE_PATH } from '@kenocyber/shared';
import { createAuthClient } from 'better-auth/react';

/**
 * Better Auth browser client.
 *
 * `VITE_API_BASE_URL` is build-time, public configuration (an URL, never a
 * secret). Cookies do all the authentication: `credentials: 'include'` sends
 * the httpOnly session cookie cross-origin to the API, and nothing
 * token-like is ever stored in JavaScript-accessible state.
 *
 * **The fallback is for the dev server, and it cannot reach `dist`.** A
 * production build with no `VITE_API_BASE_URL` is refused by `vite.config.ts`
 * before a bundle exists, because this line would otherwise ship a page that
 * opens, looks right, and can only talk to an API on the visitor's own
 * machine.
 */
export const API_BASE_URL: string =
  (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? 'http://127.0.0.1:8787';

export const authClient = createAuthClient({
  baseURL: `${API_BASE_URL}${AUTH_BASE_PATH}`,
  fetchOptions: {
    credentials: 'include',
  },
});
